const handleHeic = async (src: string) => {
  const heic2any = (await import('heic2any')).default;
  const imageBlob = await heic2any({
    blob: await fetch(src).then((response) => response.blob()),
    toType: 'image/jpeg',
    quality: 1,
  });
  // return imageBlob as Blob;
  return URL.createObjectURL(imageBlob as Blob);
};

export const getImageWidth = async (url: string, type: string) => {
  return new Promise<number>(async (resolve, reject) => {
    const img = new Image();

    if (type === 'image/heic') {
      img.src = await handleHeic(url);
    } else {
      img.src = url;
    }

    img.onload = () => {
      resolve(img.width);
    };

    img.onerror = () => {
      reject();
    };
  });
};

export const resizeImageWithCanvas = (src: string, width: number, type: string) => {
  const resizedWidth = Math.floor(width * 0.3) > 1000 ? 1000 : Math.floor(width * 0.3);
  return new Promise(async (resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    if (type === 'image/heic') {
      img.src = await handleHeic(src);
    } else {
      img.src = src;
    }

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const aspectRatio = img.width / img.height;
      const height = Math.floor(resizedWidth / aspectRatio);

      canvas.width = resizedWidth;
      canvas.height = height;

      const context = canvas.getContext('2d');
      context!.drawImage(img, 0, 0, resizedWidth, height);

      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/png');
    };
    img.onerror = () => {
      reject();
    };
  });
};

export const imageHandler = Object.assign({ getImageWidth, resizeImageWithCanvas });
